import { useCallback, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
import { auth, functions } from "../../firebase";
import CreateUserRecord from "../../Controllers/Auth/CreateUserRecord";
import { useNavigate } from "react-router-dom";
import GetSchool from "../../Controllers/Auth/GetSchool";
import { AuthErrorMessages } from "../../Helpers/ToastMessages";
import GetSchoolClasses from "../../Controllers/Auth/GetSchoolClasses";
import CheckRegistrationNoExists from "../../Controllers/Auth/CheckRegistrationNo";
import { isValidPhoneNumber } from "react-phone-number-input";
import { async } from "q";
import { httpsCallable } from "@firebase/functions";
import GetAllSchools from "../../Controllers/Schools/GetAllSchools";
import CheckDuplicateEmployeeID from "../../Controllers/Auth/CheckDuplicateEmployeeID";
export default function RegisterViewModel() {
  const navigate = useNavigate();

  const [FirstNameError, setFirstNameError] = useState(false);
  const [LastNameError, setLastNameError] = useState(false);
  const [GenderError, setGenderError] = useState(false);
  const [EmailError, setEmailError] = useState(false);
  const [UserTypeError, setUserTypeError] = useState(false);
  const [PasswordError, setPasswordError] = useState(false);
  const [ConfirmPasswordError, setConfirmPasswordError] = useState(false);
  const [AdminCNICError, setAdminCNICError] = useState(false);
  const [AdminPhoneNoError, setAdminPhoneNoError] = useState(false);
  const [AdminDesignationError, setAdminDesignationError] = useState(false);
  const [TeacherCNICError, setTeacherCNICError] = useState(false);
  const [TeacherPhoneNoError, setTeacherPhoneNoError] = useState(false);
  const [TeacherSchoolNameError, setTeacherSchoolNameError] = useState(false);
  const [TeacherEmployeeIDError, setTeacherEmployeeIDError] = useState(false);
  const [StudentSchoolNameError, setStudentSchoolNameError] = useState(false);
  const [StudentRegistrationNoError, setStudentRegistrationNoError] =
    useState(false);
  const [StudentClassError, setStudentClassError] = useState(false);
  const [ParentCNICError, setParentCNICError] = useState(false);
  const [ParentPhoneNoError, setParentPhoneNoError] = useState(false);
  const [ParentSchoolNameError, setParentSchoolNameError] = useState(false);
  const [
    ParentStudentRegistrationNoError,
    setParentStudentRegistrationNoError,
  ] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [Schools, setSchools] = useState([]);
  const [SchoolID, setSchoolID] = useState([]);
  const [SchoolClasses, setSchoolClasses] = useState([]);
  const [ButtonLoader, setButtonLoader] = useState(false);
  const [ActiveIndex, setActiveIndex] = useState(0);
  const [ChildrenIDs, setChildrenIDs] = useState([]);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [User, setUser] = useState({
    FirstName: "",
    LastName: "",
    Gender: "",
    Email: "",
    UserType: "",
    Password: "",
    ConfirmPassword: "",
    IsVerified: 0, // 0 means Not Verified
    Count: 0, // 0 means 1st verification attempt
    SchoolID: SchoolID,
  });

  const [AdminAdditionalDetails, setAdminAdditionalDetails] = useState({
    CNIC: "",
    PhoneNo: "",
    Designation: "",
  });

  const [TeacherAdditionalDetails, setTeacherAdditionalDetails] = useState({
    CNIC: "",
    PhoneNo: "",
    SchoolName: "",
    EmployeeID: "",
  });

  const [StudentAdditionalDetails, setStudentAdditionalDetails] = useState({
    SchoolName: "",
    StudentRegistrationNo: "",
    ClassID: "",
  });
  const [StudentRegistrationNo, setStudentRegistrationNo] = useState([
    {
      RegNo: "",
      StudentId: "",
      IsValid: false,
    },
  ]);

  const [ParentAdditionalDetails, setParentAdditionalDetails] = useState({
    CNIC: "",
    PhoneNo: "",
    SchoolName: "",
    StudentRegistrationNo: [],
  });

  const [TotalSchools, setTotalSchools] = useState([]);
  useEffect(() => {
    async function fetchData() {
      const schools = await GetAllSchools();
      setTotalSchools(schools);
    }
    fetchData();
  }, []);

  useEffect(() => {
    setParentAdditionalDetails({
      ...ParentAdditionalDetails,
      StudentRegistrationNo: [...StudentRegistrationNo],
    });
  }, [StudentRegistrationNo]);

  const [CnicNumber, setCnicNumber] = useState("");

  const HandleCNICFormat = (event) => {
    const limit = 13;
    setCnicNumber(event.target.value.slice(0, limit));
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function ValidateCNIC(CNIC) {
    const CNICRegex = /^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/;
    return CNICRegex.test(CNIC);
  }

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    // Same For All Errors Start
    if (
      User.FirstName === "" ||
      User.FirstName === null ||
      User.FirstName === undefined ||
      User.FirstName.length < 3
    ) {
      setFirstNameError(true);
      flag++;
    } else {
      setFirstNameError(false);
    }

    if (
      User.LastName === "" ||
      User.LastName === null ||
      User.LastName === undefined ||
      User.LastName.length < 3
    ) {
      setLastNameError(true);
      flag++;
    } else {
      setLastNameError(false);
    }

    if (
      User.Gender === "" ||
      User.Gender === null ||
      User.Gender === undefined
    ) {
      setGenderError(true);
      flag++;
    } else {
      setGenderError(false);
    }

    if (
      User.Email === "" ||
      User.Email === null ||
      User.Email === undefined ||
      !isValidEmail(User.Email)
    ) {
      setEmailError(true);
      flag++;
    } else {
      setEmailError(false);
    }

    if (
      User.UserType === "" ||
      User.UserType === null ||
      User.UserType === undefined
    ) {
      setUserTypeError(true);
      flag++;
    } else {
      setUserTypeError(false);
    }

    if (
      User.Password === "" ||
      User.Password === null ||
      User.Password === undefined ||
      User.Password.length < 6
    ) {
      setPasswordError(true);
      flag++;
    } else {
      setPasswordError(false);
    }

    if (
      User.ConfirmPassword === "" ||
      User.ConfirmPassword === null ||
      User.ConfirmPassword === undefined ||
      User.ConfirmPassword.length < 6 ||
      User.ConfirmPassword !== User.Password
    ) {
      setConfirmPasswordError(true);
      flag++;
    } else {
      setConfirmPasswordError(false);
    }
    // Same For All Errors End

    // Admin Errors Start
    if (User.UserType === "admin") {
      if (
        AdminAdditionalDetails.CNIC === "" ||
        AdminAdditionalDetails.CNIC === null ||
        AdminAdditionalDetails.CNIC === undefined ||
        !ValidateCNIC(AdminAdditionalDetails.CNIC)
      ) {
        setAdminCNICError(true);
        flag++;
      } else {
        setAdminCNICError(false);
      }

      if (
        AdminAdditionalDetails.PhoneNo === "" ||
        AdminAdditionalDetails.PhoneNo === null ||
        AdminAdditionalDetails.PhoneNo === undefined ||
        !isValidPhoneNumber(AdminAdditionalDetails.PhoneNo)
      ) {
        setAdminPhoneNoError(true);
        flag++;
      } else {
        setAdminPhoneNoError(false);
      }

      if (
        AdminAdditionalDetails.Designation === "" ||
        AdminAdditionalDetails.Designation === null ||
        AdminAdditionalDetails.Designation === undefined
      ) {
        setAdminDesignationError(true);
        flag++;
      } else {
        setAdminDesignationError(false);
      }
      // Admin Errors End

      // Teacher Errors Start
    } else if (User.UserType === "teacher") {
      if (
        TeacherAdditionalDetails.CNIC === "" ||
        TeacherAdditionalDetails.CNIC === null ||
        TeacherAdditionalDetails.CNIC === undefined ||
        !ValidateCNIC(TeacherAdditionalDetails.CNIC)
      ) {
        setTeacherCNICError(true);
        flag++;
      } else {
        setTeacherCNICError(false);
      }

      if (
        TeacherAdditionalDetails.PhoneNo === "" ||
        TeacherAdditionalDetails.PhoneNo === null ||
        TeacherAdditionalDetails.PhoneNo === undefined ||
        !isValidPhoneNumber(TeacherAdditionalDetails.PhoneNo)
      ) {
        setTeacherPhoneNoError(true);
        flag++;
      } else {
        setTeacherPhoneNoError(false);
      }

      if (
        TeacherAdditionalDetails.SchoolName === "" ||
        TeacherAdditionalDetails.SchoolName === null ||
        TeacherAdditionalDetails.SchoolName === undefined ||
        TeacherAdditionalDetails.SchoolName.length < 3
      ) {
        setTeacherSchoolNameError(true);
        flag++;
      } else {
        setTeacherSchoolNameError(false);
      }

      if (
        TeacherAdditionalDetails.EmployeeID === "" ||
        TeacherAdditionalDetails.EmployeeID === null ||
        TeacherAdditionalDetails.EmployeeID === undefined
      ) {
        setTeacherEmployeeIDError(true);
        flag++;
      } else {
        setTeacherEmployeeIDError(false);
      }
      // Teacher Errors End

      // Student Errors Start
    } else if (User.UserType === "student") {
      if (
        StudentAdditionalDetails.SchoolName === "" ||
        StudentAdditionalDetails.SchoolName === null ||
        StudentAdditionalDetails.SchoolName === undefined ||
        StudentAdditionalDetails.SchoolName.length < 3
      ) {
        setStudentSchoolNameError(true);

        flag++;
      } else {
        setStudentSchoolNameError(false);
      }

      if (
        StudentAdditionalDetails.StudentRegistrationNo === "" ||
        StudentAdditionalDetails.StudentRegistrationNo === null ||
        StudentAdditionalDetails.StudentRegistrationNo === undefined
      ) {
        setStudentRegistrationNoError(true);

        flag++;
      } else {
        setStudentRegistrationNoError(false);
      }

      if (SchoolID) {
        if (
          StudentAdditionalDetails.ClassID === "" ||
          StudentAdditionalDetails.ClassID === null ||
          StudentAdditionalDetails.ClassID === undefined
        ) {
          setStudentClassError(true);

          flag++;
        } else {
          setStudentClassError(false);
        }
      }
      // Student Errors End

      // Parent Errors Start
    } else if (User.UserType === "parent") {
      StudentRegistrationNo?.map((item) => {
        if (item.IsValid === false) {
          flag++;
        }
      });

      if (
        ParentAdditionalDetails.CNIC === "" ||
        ParentAdditionalDetails.CNIC === null ||
        ParentAdditionalDetails.CNIC === undefined ||
        !ValidateCNIC(ParentAdditionalDetails.CNIC)
      ) {
        setParentCNICError(true);
        flag++;
      } else {
        setParentCNICError(false);
      }

      if (
        ParentAdditionalDetails.PhoneNo === "" ||
        ParentAdditionalDetails.PhoneNo === null ||
        ParentAdditionalDetails.PhoneNo === undefined ||
        !isValidPhoneNumber(ParentAdditionalDetails.PhoneNo)
      ) {
        setParentPhoneNoError(true);
        flag++;
      } else {
        setParentPhoneNoError(false);
      }

      if (
        ParentAdditionalDetails.SchoolName === "" ||
        ParentAdditionalDetails.SchoolName === null ||
        ParentAdditionalDetails.SchoolName === undefined ||
        ParentAdditionalDetails.SchoolName < 3
      ) {
        setParentSchoolNameError(true);
        flag++;
      } else {
        setParentSchoolNameError(false);
      }

      if (
        ParentAdditionalDetails.StudentRegistrationNo === "" ||
        ParentAdditionalDetails.StudentRegistrationNo === null ||
        ParentAdditionalDetails.StudentRegistrationNo === undefined
      ) {
        setParentStudentRegistrationNoError(true);
        flag++;
      } else {
        setParentStudentRegistrationNoError(false);
      }
      // Parent Errors End
    }

    return flag;
  }, [
    User.FirstName,
    User.LastName,
    User.Gender,
    User.Email,
    User.UserType,
    User.Password,
    User.ConfirmPassword,

    AdminAdditionalDetails.CNIC,
    AdminAdditionalDetails.PhoneNo,
    AdminAdditionalDetails.Designation,

    TeacherAdditionalDetails.CNIC,
    TeacherAdditionalDetails.PhoneNo,
    TeacherAdditionalDetails.SchoolName,
    TeacherAdditionalDetails.EmployeeID,
    StudentAdditionalDetails.SchoolName,
    StudentAdditionalDetails.StudentRegistrationNo,

    ParentAdditionalDetails.CNIC,
    ParentAdditionalDetails.PhoneNo,
    ParentAdditionalDetails.SchoolName,
    ParentAdditionalDetails.StudentRegistrationNo,

    StudentRegistrationNo,
    StudentAdditionalDetails.ClassID,
    SchoolID,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  // useEffect(() => {
  //   async function fetchData() {
  //     const schools = await GetSchool(
  //       TeacherAdditionalDetails?.SchoolName ||
  //         StudentAdditionalDetails?.SchoolName ||
  //         ParentAdditionalDetails?.SchoolName
  //     );

  //     if (schools) {
  //       setSchoolID(schools[0]?.id);
  //       setSchools(schools);
  //     }
  //   }
  //   fetchData();
  // }, [
  //   TeacherAdditionalDetails?.SchoolName,
  //   StudentAdditionalDetails?.SchoolName,
  //   ParentAdditionalDetails?.SchoolName,
  // ]);

  useEffect(() => {
    async function fetchData() {
      const schools = await GetSchool(
        StudentAdditionalDetails?.SchoolName ||
          ParentAdditionalDetails?.SchoolName
      );

      if (schools) {
        setSchoolID(schools[0]?.id);
        setSchools(schools);
      }
    }
    fetchData();
  }, [
    StudentAdditionalDetails?.SchoolName,
    ParentAdditionalDetails?.SchoolName,
  ]);

  // Get School Classes Start
  useEffect(() => {
    async function fetchData() {
      if (SchoolID) {
        const schoolClasses = await GetSchoolClasses(SchoolID);

        setSchoolClasses(schoolClasses);
      }
    }
    fetchData();
  }, [SchoolID]);
  // Get School Classes End

  const RegisterUser = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      // setButtonLoader(true);
      // setFormDisabled(true);
      let UserFinalObject = {
        ...User,
        AdditionalDetails:
          User.UserType === "admin"
            ? AdminAdditionalDetails
            : User.UserType === "teacher"
            ? TeacherAdditionalDetails
            : User.UserType === "student"
            ? StudentAdditionalDetails
            : User.UserType === "parent"
            ? ParentAdditionalDetails
            : "",
      };

      if (User.UserType !== "admin") {
        UserFinalObject = { ...UserFinalObject, SchoolID };

        if (Schools.length !== 0) {
          // Check Registration no duplication

          if (User.UserType === "student") {
            const resp = await CheckRegistrationNoExists(
              UserFinalObject.AdditionalDetails.StudentRegistrationNo,
              SchoolID
            );
            if (resp) {
              AuthErrorMessages("student/registration-number-exists");
              setButtonLoader(false);
              setFormDisabled(false);
              return;
            }
          }

          if (User.UserType === "teacher") {
            const resp = await CheckDuplicateEmployeeID(
              UserFinalObject.AdditionalDetails.EmployeeID,
              SchoolID
            );
            if (resp) {
              AuthErrorMessages("teacher/employee-id-exists");
              setButtonLoader(false);
              setFormDisabled(false);
              return;
            }
          }

          createUserWithEmailAndPassword(auth, User.Email, User.Password)
            .then(async (userCredential) => {
              const user = userCredential.user;
              if (user.uid !== null) {
                await CreateUserRecord(UserFinalObject, user, Schools[0]?.id);
                sendEmailVerification(user).then(() => {
                  setButtonLoader(false);
                  navigate("/email-verification");
                });
              }
              updateProfile(user, {
                displayName: User.FirstName + " " + User.LastName,
              }).then(() => {});
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              setButtonLoader(false);
              setFormDisabled(false);
              AuthErrorMessages(errorCode);
            });
        } else {
          AuthErrorMessages("school/school-does-not-exist");
          setFormDisabled(false);
          setButtonLoader(false);
        }
      } else {
        createUserWithEmailAndPassword(auth, User.Email, User.Password)
          .then(async (userCredential) => {
            const user = userCredential.user;
            setButtonLoader(true);
            if (user.uid !== null) {
              await CreateUserRecord(UserFinalObject, user, "");
              sendEmailVerification(user).then(() => {
                navigate("/email-verification");
              });
            }
            updateProfile(user, {
              displayName: User.FirstName + " " + User.LastName,
            }).then(async () => {
              // Function for Super Admin
              // const AddSuperAdminRole = httpsCallable(
              //   functions,
              //   "AddSuperAdminRole"
              // );
              // let resp = await AddSuperAdminRole({
              //   email: "hamdullah@logicworms.com",
              // });
              // console.log(resp);
            });
          })
          .catch((error) => {
            setButtonLoader(false);
            setFormDisabled(false);
            const errorCode = error.code;
            const errorMessage = error.message;
            AuthErrorMessages(errorCode);
          });
      }
    } else {
      setFormDisabled(false);
      setButtonLoader(false);
    }
  };

  return [
    User,
    setUser,
    AdminAdditionalDetails,
    setAdminAdditionalDetails,
    TeacherAdditionalDetails,
    setTeacherAdditionalDetails,
    StudentAdditionalDetails,
    setStudentAdditionalDetails,
    ParentAdditionalDetails,
    setParentAdditionalDetails,
    RegisterUser,
    CnicNumber,
    HandleCNICFormat,
    FirstNameError,
    LastNameError,
    GenderError,
    EmailError,
    UserTypeError,
    PasswordError,
    ConfirmPasswordError,
    AdminCNICError,
    AdminPhoneNoError,
    AdminDesignationError,
    TeacherCNICError,
    TeacherPhoneNoError,
    TeacherSchoolNameError,
    TeacherEmployeeIDError,
    StudentSchoolNameError,
    StudentRegistrationNoError,
    StudentClassError,
    ParentCNICError,
    ParentPhoneNoError,
    ParentSchoolNameError,
    ParentStudentRegistrationNoError,
    FormDisabled,
    SchoolClasses,
    ButtonLoader,
    setButtonLoader,
    SchoolID,
    ActiveIndex,
    setActiveIndex,
    ChildrenIDs,
    setChildrenIDs,
    StudentRegistrationNo,
    setStudentRegistrationNo,
    IsCheckError,
    TotalSchools,
    setSchoolID,
  ];
}
